import { GetSessionV2Response } from "@endavaaccorplus/payments-common/schemas";

export const getSubscriptionType = (session: GetSessionV2Response) => {
  switch (session.type) {
    case "renew-public":
      return session.membership?.status === "expired"
        ? "Renewal - Late"
        : "Renewal - On time";
    case "register-public":
    case "register-partner":
      return session.membership?.status === "lapsed" ? "Renewal - Late" : "New";
    default:
      return "New";
  }
};
